import ObtainLicensePage from "../components/obtainLicense/main";

const ObtainLicense = () => {
  return <ObtainLicensePage />;
};

export default ObtainLicense;
